import React, { useEffect, useState } from "react";
import axiosInstance from "../../../axios";
import { Loading } from "../../Other/Loading";

const AdminListData = () => {
  const [adminData, setAdminData] = useState({});
  const fetch = () => {
    axiosInstance
      .get("admin/statistics")
      .then((res) => {
        setAdminData(res?.data?.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    fetch();
  }, []);
  return (
    <div className="flex-dashboard-new">
      <div className={`box-shadow-05 Dashboard-color-one`}>
        <p className="font-custom-p">Courses</p>
        <p className={`font-increase color-one`}>
          {adminData.hasOwnProperty("courses") ? (
            adminData.courses
          ) : (
            <div className="admindata-loading">
              <Loading />
            </div>
          )}
        </p>
        <div className="dashboard-main-new">
          <p className="this-month-style">This Month</p>
          <p className={` color-one flex-text-one`}>
            {adminData?.thisMonthCourses}
          </p>
        </div>
      </div>

      <div className={`box-shadow-05 Dashboard-color-two`}>
        <p className="font-custom-p">Instructors</p>
        <p className={`font-increase color-two`}>
          {adminData.hasOwnProperty("instructors") ? (
            adminData.instructors
          ) : (
            <div className="admindata-loading">
              <Loading />
            </div>
          )}
        </p>
        <div className="dashboard-main-new">
          <p className="this-month-style">This Month</p>
          <p className={` color-two flex-text-one`}>
            {adminData?.thisMonthInstructors}
          </p>
        </div>
      </div>

      <div className={`box-shadow-05 Dashboard-color-three`}>
        <p className="font-custom-p">Students</p>
        <p className={`font-increase color-three`}>
          {adminData.hasOwnProperty("students") ? (
            adminData.students
          ) : (
            <div className="admindata-loading">
              <Loading />
            </div>
          )}
        </p>
        <div className="dashboard-main-new">
          <p className="this-month-style">This Month</p>
          <p className={` color-three flex-text-one`}>
            {adminData?.thisMonthStudents}
          </p>
        </div>
      </div>

      <div className={`box-shadow-05 Dashboard-color-four`}>
        <p className="font-custom-p">Courses Under Review</p>
        <p className={`font-increase color-four`}>
          {adminData.hasOwnProperty("moderation") ? (
            adminData.moderation
          ) : (
            <div className="admindata-loading">
              <Loading />
            </div>
          )}
        </p>
        <div className="dashboard-main-new">
          <p className="this-month-style">This Month</p>
          <p className={` color-four flex-text-one`}>
            {adminData?.thisMonthStudents}
          </p>
        </div>
      </div>

      <div className={`box-shadow-05 Dashboard-color-five`}>
        <p className="font-custom-p">Webinar</p>
        <p className={`font-increase color-five`}>
          {adminData.hasOwnProperty("webinars") ? (
            adminData.webinars
          ) : (
            <div className="admindata-loading">
              <Loading />
            </div>
          )}
        </p>
        <div className="dashboard-main-new">
          <p className="this-month-style">This Month</p>
          <p className={` color-five flex-text-one`}>
            {adminData?.thisMonthWebinars}
          </p>
        </div>
      </div>
    </div>
  );
};

export default AdminListData;
